import { createComponent } from "@helpers/admin";
import ContactSectionComponent from "@template/blocks/ContactSection/component";

export const Contact = createComponent({
  label: "Contact",
  component: ContactSectionComponent,
  fields: {
    title: {
      type: "textarea",
      label: "Title",
    },
    description: {
      type: "textarea",
      label: "Description",
    },
    context: {
      label: "Context",
      type: "select",
      options: [
        {
          label: "Support Ticket",
          value: "supportTicket",
        },
        {
          label: "Webinar",
          value: "webinar",
        },
        {
          label: "Reseller Enquiry",
          value: "resellerEnquiry",
        },
      ],
    },
    altBackground: {
      label: "Alternative Layout",
      type: "boolean",
    },
    infoBlocks: {
      label: "Info Blocks",
      type: "boolean",
    },
    reviews: {
      label: "Show Reviews",
      type: "boolean",
    },
  },
});
